const menu_items = {

    skenderija: [
        {
            id: 'posiljke_skenderija',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljke_radnja_obrada',
                    title: 'Obrada pošiljki',
                    type: 'item',
                    url: '/posiljke/radnja-obrada',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_provjeriti',
                    title: 'Pošiljke za provjeriti',
                    type: 'item',
                    url: '/posiljke/radnja-provjeriti',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_zavrsene',
                    title: 'Završene pošiljke',
                    type: 'item',
                    url: '/posiljke/radnja-zavrsene',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'skenderija_prenos',
            title: 'Prenos',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljkeItem9',
                    title: 'Prenosne pošiljke',
                    type: 'item',
                    url: '/posiljke/prenosne-posiljke',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'pakovanje_skenderija',
            title: 'Pakovanje',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'pakovanje_posiljke',
                    title: 'Pakovanje pošiljki',
                    type: 'item',
                    url: '/posiljke/pakovanje-posiljke',
                    icon: 'feather icon-home',
                },
                {
                    id: 'zapakovane_posiljke',
                    title: 'Zapakovane pošiljke',
                    type: 'item',
                    url: '/posiljke/zapakovane-posiljke',
                    icon: 'feather icon-home',
                },
            ]
        },

        {
            id: 'kasa_skenderija',
            title: 'Kasa',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'racuni_za_izmjenu_item',
                    title: 'Računi za izmjenu',
                    type: 'item',
                    url: '/posiljke/racuni-rucna-izmjena',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem7',
                    title: 'Export kasa',
                    type: 'item',
                    url: '/posiljke/export-kasa',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem6',
                    title: 'Suma otkupnina',
                    type: 'item',
                    url: '/posiljke/suma-otkupnina',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'ostalo_skenderija',
            title: 'Ostalo',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem10',
                    title: 'Zaključi dan',
                    type: 'item',
                    url: '/posiljke/zakljuci-dan',
                    icon: 'feather icon-home',
                }
            ]
        }
    ],

    dobrinja: [
        {
            id: 'posiljke',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljke_radnja_obrada',
                    title: 'Obrada pošiljki',
                    type: 'item',
                    url: '/posiljke/radnja-obrada',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_provjeriti',
                    title: 'Pošiljke za provjeriti',
                    type: 'item',
                    url: '/posiljke/radnja-provjeriti',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_zavrsene',
                    title: 'Završene pošiljke',
                    type: 'item',
                    url: '/posiljke/radnja-zavrsene',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'dobrinja_prenos',
            title: 'Prenos',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem8',
                    title: 'Export prenosnica',
                    type: 'item',
                    url: '/posiljke/export-prenosnica',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'dobrinja_ostalo',
            title: 'Ostalo',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem11',
                    title: 'Taxi',
                    type: 'item',
                    url: '/posiljke/taxi',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem10',
                    title: 'Zaključi dan',
                    type: 'item',
                    url: '/posiljke/zakljuci-dan',
                    icon: 'feather icon-home',
                }
            ]
        }
    ],

    bulevar: [
        {
            id: 'bulevar_posiljke',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljke_radnja_obrada',
                    title: 'Obrada pošiljki',
                    type: 'item',
                    url: '/posiljke/radnja-obrada',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_provjeriti',
                    title: 'Pošiljke za provjeriti',
                    type: 'item',
                    url: '/posiljke/radnja-provjeriti',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_radnja_zavrsene',
                    title: 'Završene pošiljke',
                    type: 'item',
                    url: '/posiljke/radnja-zavrsene',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'bulevar_prenos',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljkeItem8',
                    title: 'Export prenosnica',
                    type: 'item',
                    url: '/posiljke/export-prenosnica',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'bulevar_ostalo',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'posiljkeItem11',
                    title: 'Taxi',
                    type: 'item',
                    url: '/posiljke/taxi',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem10',
                    title: 'Zaključi dan',
                    type: 'item',
                    url: '/posiljke/zakljuci-dan',
                    icon: 'feather icon-home',
                }
            ]
        }
    ],

    administracija: [
        {
            id: 'administracija_posiljke',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljke_admin_obrada',
                    title: 'Nabavka',
                    type: 'item',
                    url: '/posiljke/administracija-obrada',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_admin_provjeriti',
                    title: 'Pošiljke za provjeru',
                    type: 'item',
                    url: '/posiljke/administracija-provjeriti',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_admin_zavrsene',
                    title: 'Završene pošiljke',
                    type: 'item',
                    url: '/posiljke/administracija-zavrsene',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljke_admin_pomjerene',
                    title: 'Pomjerene pošiljke',
                    type: 'item',
                    url: '/posiljke/administracija-pomjerene',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'administracija_ostalo',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem11',
                    title: 'Prenos robe',
                    type: 'item',
                    url: '/prenos-robe',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem10',
                    title: 'Zaključi dan',
                    type: 'item',
                    url: '/posiljke/zakljuci-dan',
                    icon: 'feather icon-home',
                }
            ]
        }
    ],

    online_prodaja: [
        {
            id: 'online_prodaja_posiljke',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem1',
                    title: 'Dodaj pošiljku',
                    type: 'item',
                    url: '/posiljke/online-prodaja',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem2',
                    title: 'Obrada pošiljki',
                    type: 'item',
                    url: '/posiljke/online-prodaja-obrada',
                    icon: 'feather icon-home',
                },
                {
                    id: 'onlineProdajaZavrseneItem',
                    title: 'Završene pošiljke',
                    type: 'item',
                    url: '/posiljke/online-prodaja-zavrsene',
                    icon: 'feather icon-home',
                },
                {
                    id: 'onlineProdajaProvjeritiItem',
                    title: 'Pošiljke za provjeru',
                    type: 'item',
                    url: '/posiljke/online-prodaja-provjera',
                    icon: 'feather icon-home',
                },
                {
                    id: 'kontrolnaProvjeritiItem',
                    title: 'Kontrolne pošiljke',
                    type: 'item',
                    url: '/posiljke/online-prodaja-kontrolne',
                    icon: 'feather icon-home',
                },
                {
                    id: 'onlineProdajaPomjereneItem',
                    title: 'Pomjerene pošiljke',
                    type: 'item',
                    url: '/posiljke/online-prodaja-promjerene',
                    icon: 'feather icon-home',
                },
                {
                    id: 'onlineProdajaObavijestitiItem',
                    title: 'Obavijestiti kupca',
                    type: 'item',
                    url: '/posiljke/online-prodaja-obavijestiti',
                    icon: 'feather icon-home',
                },
                {
                    id: 'onlineProdajaSvePosiljkeItem',
                    title: 'Sve pošiljke',
                    type: 'item',
                    url: '/posiljke/online-prodaja-sve-posiljke',
                    icon: 'feather icon-home',
                }
            ]
        },

        {
            id: 'online_prodaja_ostalo',
            title: 'Ostalo',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'posiljkeItem222',
                    title: 'Export pošta',
                    type: 'item',
                    url: '/posiljke/export-posta',
                    icon: 'feather icon-home',
                },
                {
                    id: 'stakla_mapiranje',
                    title: 'Mapiranje stakala',
                    type: 'item',
                    url: '/posiljke/stakla-mapiranje',
                    icon: 'feather icon-home',
                },
                {
                    id: 'posiljkeItem10',
                    title: 'Ostalo',
                    type: 'item',
                    url: '/posiljke/zakljuci-dan',
                    icon: 'feather icon-home',
                }
            ]
        }
    ],

    student: [
        {
            id: 'student_prodaja_posiljke',
            title: 'Pošiljke',
            type: 'group',
            icon: 'icon-navigation',

            children: [
                {
                    id: 'student_dodaj_posiljku',
                    title: 'Dodaj pošiljku',
                    type: 'item',
                    url: '/kontrolne-posiljke/student',
                    icon: 'feather icon-home',
                },
            ]
        }
    ],

    crm: [
        {
            id: 'crm_group',
            title: 'CRM',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'crm_inventar',
                    title: 'Inventar',
                    type: 'item',
                    url: '/crm/inventar',
                    icon: 'feather icon-package',
                },
                {
                    id: 'crm_inventura',
                    title: 'Inventura telefona',
                    type: 'item',
                    url: '/crm/inventura',
                    icon: 'feather icon-check-square',
                },
                {
                    id: 'crm_otkup',
                    title: 'Otkup',
                    type: 'item',
                    url: '/crm/otkup',
                    icon: 'feather icon-shopping-cart',
                },
                {
                    id: 'crm_skeniranje_ugovora',
                    title: 'Skeniranje ugovora',
                    type: 'item',
                    url: '/crm/skeniranje-ugovora',
                    icon: 'feather icon-camera',
                },
                {
                    id: 'crm_skeniranje_kalkulacija',
                    title: 'Skeniranje kalkulacija',
                    type: 'item',
                    url: '/crm/skeniranje-kalkulacija',
                    icon: 'feather icon-file-text',
                },
                {
                    id: 'crm_prijenosnice',
                    title: 'Prijenosnice poslovnice',
                    type: 'item',
                    url: '/crm/prijenosnice',
                    icon: 'feather icon-repeat',
                },
                {
                    id: 'crm_uvoz_kina',
                    title: 'Uvoz Kina',
                    type: 'item',
                    url: '/crm/uvoz-kina',
                    icon: 'feather icon-globe',
                },
                {
                    id: 'crm_prodaja',
                    title: 'Fakture - pregled prodaje',
                    type: 'item',
                    url: '/crm/prodaja',
                    icon: 'feather icon-tag',
                },
                {
                    id: 'crm_rezervacije',
                    title: 'Rezervacije',
                    type: 'item',
                    url: '/crm/rezervacije',
                    icon: 'feather icon-bookmark',
                },
                {
                    id: 'crm_tabela_novca',
                    title: 'Tabela novca',
                    type: 'item',
                    url: '/crm/tabela-novca',
                    icon: 'feather icon-credit-card',
                },
                {
                    id: 'crm_izvjestaji',
                    title: 'Izvještaji',
                    type: 'item',
                    url: '/crm/izvjestaji',
                    icon: 'feather icon-bar-chart-2',
                },
                {
                    id: 'crm_asistent',
                    title: 'Asistent (bot)',
                    type: 'item',
                    url: '/crm/asistent',
                    icon: 'feather icon-message-circle',
                },
                {
                    id: 'crm_sabloni_poruka',
                    title: 'Šabloni poruka',
                    type: 'item',
                    url: '/crm/sabloni-poruka',
                    icon: 'feather icon-file-text',
                },
                {
                    id: 'crm_kalkulator_mikrofin',
                    title: 'Kalkulator rata',
                    type: 'item',
                    url: '/crm/kalkulator-mikrofin',
                    icon: 'feather icon-percent',
                },
                {
                    id: 'crm_lista_cekanja',
                    title: 'Lista čekanja',
                    type: 'item',
                    url: '/crm/lista-cekanja',
                    icon: 'feather icon-clock',
                },
                {
                    id: 'crm_admin_postavke',
                    title: 'Admin postavke',
                    type: 'item',
                    url: '/crm/admin-postavke',
                    icon: 'feather icon-settings',
                },
            ]
        }
    ],

    // Leave this to avoid having to fix BreadCrumbs that throws an error, even though we don't need them
    items: [
    ]
}

export default menu_items;